export default class SelectAllCheckboxes extends Backbone.View
  initialize: (opts) ->
    @$selectAllCheckbox = @$(opts.selectAllCheckbox)
    @childCheckboxSelector = opts.childCheckboxes

    @selectAllCallback = opts.selectAllCallback
    @childCheckboxCallback = opts.childCheckboxCallback

    @$selectAllCheckbox.on("click", @selectAllClick)
    @$el.on("click", @childCheckboxSelector, @childCheckboxClick)

  selectAllClick: (e) =>
    resourceId = $(e.currentTarget).val()
    isChecked = $(e.currentTarget).prop("checked")

    @$selectAllCheckbox
      .removeClass("checkbox-indeterminate")
      .prop("indeterminate", false)

    @$(@childCheckboxSelector).prop("checked", isChecked)
    if @selectAllCallback then @selectAllCallback(resourceId, isChecked, @$(@childCheckboxSelector))

  childCheckboxClick: (e) =>
    @updateSelectAll()
    if @childCheckboxCallback then @childCheckboxCallback(e)

  updateSelectAll: ->
    @$selectAllCheckbox
      .removeClass("checkbox-indeterminate")
      .prop("indeterminate", false)

    if @_allCheckboxesAreSelected()
      @$selectAllCheckbox.prop("checked", true)
    else if @_someCheckboxesAreSelected()
      @$selectAllCheckbox
        .addClass("checkbox-indeterminate")
        .prop("indeterminate", true)
        .prop("checked", true)
    else
      @$selectAllCheckbox.prop("checked", false)

  selectedCheckboxes: ->
    @$("#{@childCheckboxSelector}:checked")

  _someCheckboxesAreSelected: ->
    0 < @selectedCheckboxes().length < @$(@childCheckboxSelector).length

  _allCheckboxesAreSelected: ->
    @selectedCheckboxes().length == @$(@childCheckboxSelector).length



// WEBPACK FOOTER //
// ./app/javascript/backbone/shared/views/select_all_checkboxes_view.js.coffee